import { Space, Skeleton, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

const Activation = ({ product, activity }) => {
  const { t, i18n } = useTranslation();

  return (
    <Space size={20} direction='vertical'>
      {product?.description && (
        <Skeleton
          title={false}
          paragraph={{ rows: 3 }}
          loading={activity}
          active
        >
          <Space size={20} direction='vertical'>
            <h3>{t('pages.productCard.description')}</h3>
            <Typography>
              {parse(
                i18n.language === 'en'
                  ? product.description
                  : product.description_lv
              )}
            </Typography>
          </Space>
        </Skeleton>
      )}
    </Space>
  );
};

export default Activation;
